import {
    StyleSheet
} from "react-native";
import type {
    InputGroupTextColorConstantType
} from "./type";

export const getInputGroupTextColor = ({
    isAttached,
    isDisabled,
    colors
}: InputGroupTextColorConstantType): string => {
    if(isDisabled) {
        return colors.system.state.content.disabled.neutral;
    }

    return isAttached ? colors.content.text.mid : colors.content.text.low;
};

const stylesheet = StyleSheet.create({
    text: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 0
    }
});
export default stylesheet;
